<template>
  <v-card :height="fillHeight ? '100%' : 'auto'">
    <v-panel-title @click="switchItems()" :value="this.isLoaded && this.items.length > 0" :caption="this.isLoaded ? 'Кратко' : 'Подробно'" :expandable="this.items.length > 0">
      <div
        v-show="isLoading"
        class="text-xs-center">
        <v-progress-circular
          indeterminate
          color="primary"
        ></v-progress-circular>
      </div>
      <div v-show="!isLoading">
        <div>
          Реорганизации({{items.length}}):
        </div>  
        <v-flex v-if="this.items.length===0">
          Данные не найдены.
        </v-flex>
            <template v-for="reorg in items">
              <div v-if="reorg.restricted && reorg.restricted.code > 0">Доступ ограничен <span v-html="renderDateSince(reorg.restricted)"></span></div>            
              <div>
                <b>{{formats.blank(reorg.created, formats.formatDate)}}</b> {{reorg.form}}
              </div>                  
              <div v-show = "isLoaded">
                  <template v-for="item in reorg.reorgees">
                    <v-flex pl-2>
                      <div v-html="renderReference(item)">
                      </div>
                      <v-flex pl-2>
                        <div>ИНН <b><span v-html="renderInnHtml(item.inn)"></span></b>
                        </div>
                        <span v-html="renderDateSince(item)"></span>
                        {{item.nextState}}
                      </v-flex>
                    </v-flex>
                  </template>
              </div>      
          </template>
      </div>  
      </v-panel-title>
      <v-card-text v-show="isLoaded" class="pt-0">
      <div v-show="!isLoading">
      </div>  
      </v-card-text>
  </v-card>
</template>

<script>
  import { mapGetters } from 'vuex'
  import server from '../../api/server'
  import apimix from '../common/apimix'
  import vPanelTitle from './PanelTitle'

  export default {
    name: 'v-reorg-panel',
    components: {vPanelTitle},
    mixins: [apimix],
    data: () => ({
      id: null,
      items: [],
      item: null,
      isLoaded: false,
      isLoading: false
    }),
    props: {
      ogrn: {
        type: Number,
        default: null
      },
      fillHeight: {
        type: Boolean,
        default: false
      }
    },
    created () {
    },
    watch: {
      ogrn: function (newVal, oldVal) { // watch it
        this.id = newVal
        if (this.id) {
          this.fetchItems()
        }
      }
    },
    computed: {
      ...mapGetters({
        renderReference: 'renderReference',
        renderInnHtml: 'renderInnHtml',
        renderDateSince: 'renderDateSince'
      })
    },
    methods: {
      switchItems () {
        this.isLoaded = !this.isLoaded
        if (this.isLoaded && this.items.length === 0) {
          this.fetchItems()
        }
      },
      getItems (id, cb) {
        const cbError = (e) => {
          this.isLoading = false
          this.$store.commit('setErrorStatus', {error: e, context: 'Ошибка сервера при получении информации о реорганизации компании из ЕГРЮЛ '})
        }
        server.openApiGet(
          '/openapi/companies/' + id + '/reorgs',
          cb,
          cbError)
      },
      fetchItems () {
        if (this.id && !this.isLoading) {
          this.items = []
          this.isLoading = true
          this.getItems(this.id, (data) => {
            this.isLoading = false
            if (data && data.length > 0) {
              this.items = data
            }
          })
        }
      }
    }
  }

</script>




// WEBPACK FOOTER //
// ReorgPanel.vue?18d3757e